/**
 * PackshotScoresContext - Provides per-asset packshot scores to image cards.
 *
 * Avoids deep prop threading through 5+ component levels.
 * Wrap in ReadinessProductDetail, consume in ImageCardContent.
 */

import { createContext, useContext } from 'react'

interface AssetScore {
  score: number
  category: string
}

const PackshotScoresContext = createContext<Map<string, AssetScore>>(new Map())

export const PackshotScoresProvider = PackshotScoresContext.Provider

export function useAssetPackshotScore(assetId: string): AssetScore | null {
  const map = useContext(PackshotScoresContext)
  return map.get(assetId) ?? null
}
